import RoleManagementDetail from '@/models/RoleManagement/RoleManagementDetail';

export default class RoleManagementDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.roleManagementId  = '';
		this.roleManagementName = '';
		this.functionInfoId  = '';
		this.functionInfoName = '';
		this.allowCreate = false;
		this.allowRead = false;
		this.allowUpdate = false;
		this.allowDelete = false;
		this.showInMenu = false;
		this.allowDownload = false;
		this.allowPrint = false;
		this.allowUpload = false;
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			roleManagementId : '0',
			roleManagementName : '0',
			functionInfoId : '0',
			functionInfoName : '0',
			allowCreate : '0',
			allowRead : '0',
			allowUpdate : '0',
			allowDelete : '0',
			showInMenu : '0',
			allowDownload : '0',
			allowPrint : '0',
			allowUpload : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}